
import { Location } from '@angular/common';
import { Component, Input, OnInit,  OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PatientVisitsService } from './../patient-visit.service';
import { PatientVisit } from './../patient-visit';

import { takeUntil } from 'rxjs/operators' ;  import { Subject } from 'rxjs';
import { UserSessionService } from '../../../app-user-session.service';
import { getDateObj, getNgbTime } from '../../../shared/shared';
@Component({
    selector: 'sanabel-closeVisit',
    templateUrl: './close-patient-visit.component.html'
})
export class ClosePatVisit implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    @Input() patVisit: PatientVisit;
    endTimeNgb: any;
    msgDataToggle: boolean = true;
    constructor(
        public translate: TranslateService,
        private _patientVisitsService: PatientVisitsService,
        private _USS: UserSessionService,
        private _location: Location,
        ) {
    }


    onClicked(e: number): void {
        switch (e) {
            case 1: //save code
                this.save();
                break;
            default:
                this.cancel();
        }
    }

    ngOnInit() {
        this.endTimeNgb = getNgbTime(new Date());
        if (this.patVisit == undefined)
        this.patVisit = <any>{};
        this.getVisit$();
         const  visitData = this._USS.getModalKey('ClosePatVisit')["inputs"];
        this._getPatVisit( visitData['visitSerial']);
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    getVisit$() {
        this._USS.getModalKey$().pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.name == 'ClosePatVisit' && keys.inputs) {
                    this._getPatVisit(keys.inputs['visitSerial']);
                }
            });
    }
    private _getPatVisit(visitNo: number) {
      
        let nextVisitStatus = 2;  // send the next value of VisitStatus of currnet component for specific validation in Case Close visit Status Will be = 2
        if (visitNo > 0) {
           
            this._patientVisitsService.getSpecificVisit(visitNo, nextVisitStatus)
                .subscribe(
                (visit) => {
                    if (visit['returnFlag']) {
                        this._setEditPatVisit(visit.data[0]);
                        this.msgDataToggle = true;
                       
                    }
                }, err => console.error(err),
                () => {
                });
        }
        

    }

    private _setEditPatVisit(patVisit: PatientVisit) {
        this.patVisit = patVisit;
    }

    save() {
        this.patVisit.visitStatus = 2;
        this.patVisit.endDate = getDateObj(this.patVisit.endDateNgb, this.endTimeNgb) ;
        let patVisit = this.patVisit ;
        delete  patVisit.endDateNgb ;
        this._patientVisitsService.updateCloseSpecificVisit(patVisit)
            .subscribe(res => {
                if(res.returnFlag)
                       this._USS.closeModalKey('ClosePatVisit', res.returnFlag);
            }, error => console.log(error)
            );
           close();
    }

    cancel(showToast = true) {
        this._USS.closeModalKey('ClosePatVisit', 'Cross click');
    }

    _goBack(): void {
        this._location.back();
    }

}
